import { api } from './index';

const BASE_PATH = '/api/internal/groups';

export type Group = {
  id: number;
  name: string;
  coverageAlertsEnabled: boolean;
  patientsCount: number;
  caregiversCount: number;
  usersCount: number;
  patientIds: number[];
  caregiverIds: number[];
  userIds: number[];
  humanCreatedAt: string;
};

export interface GroupForm {
  id?: number;
  name: string;
  patientIds?: number[];
  caregiverIds?: number[];
  userIds?: number[];
  coverageAlertsEnabled?: boolean;
}

export type GroupFilter = {
  id: number;
  name: string;
};

export const groupsApi = {
  index(): Promise<Array<Group>> {
    return api({
      method: 'get',
      url: BASE_PATH,
    }).then(response => response.data.groups);
  },
  indexForFilters(): Promise<Array<GroupFilter>> {
    return api({
      method: 'get',
      url: `${BASE_PATH}?for_filters=true`,
    }).then(response => response.data.groups);
  },
  show(id: number): Promise<Group> {
    return api({
      method: 'get',
      url: `${BASE_PATH}/${id}`,
    }).then(response => response.data.group);
  },
  create(groupForm: GroupForm): Promise<Group> {
    return api({
      method: 'post',
      url: BASE_PATH,
      data: { group: groupForm },
    }).then(response => response.data.group);
  },
  update(groupForm: Partial<GroupForm>): Promise<Group> {
    return api({
      method: 'put',
      url: `${BASE_PATH}/${groupForm.id}`,
      data: { group: groupForm },
    }).then(response => response.data.group);
  },
  destroy(id: number): Promise<void> {
    return api({
      method: 'delete',
      url: `${BASE_PATH}/${id}`,
    });
  },
};
